var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "text-center mt-5" },
    [
      _c(
        "b-card",
        { staticClass: "mx-auto", staticStyle: { "max-width": "400px" } },
        [
          _c("h3", { staticClass: "mb-4" }, [_vm._v("Connexion")]),
          !_vm.emailSent
            ? _c(
                "div",
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.requestMagicLink.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Adresse email",
                            "label-for": "email-input",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "email-input",
                              type: "email",
                              required: "",
                              placeholder: "votre@email.fr",
                            },
                            model: {
                              value: _vm.email,
                              callback: function ($$v) {
                                _vm.email = $$v
                              },
                              expression: "email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mb-3",
                          model: {
                            value: _vm.rememberMe,
                            callback: function ($$v) {
                              _vm.rememberMe = $$v
                            },
                            expression: "rememberMe",
                          },
                        },
                        [_vm._v(" Rester connecté (30 jours) ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            block: "",
                            disabled: _vm.loading || !_vm.email,
                          },
                        },
                        [
                          _vm.loading
                            ? _c(
                                "span",
                                [
                                  _c("b-spinner", { attrs: { small: "" } }),
                                  _vm._v(" Envoi en cours... "),
                                ],
                                1
                              )
                            : _c("span", [
                                _vm._v("Envoyer le lien de connexion"),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.error
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { variant: "danger", show: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.error) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("b-alert", { attrs: { variant: "success", show: "" } }, [
                    _c("h5", [_vm._v("Vérifiez votre boîte mail")]),
                    _c("p", [
                      _vm._v(" Si l'adresse "),
                      _c("strong", [_vm._v(_vm._s(_vm.email))]),
                      _vm._v(
                        " est associée à un compte, un lien de connexion vous a été envoyé. "
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "Vérifiez votre boîte de réception (et vos spams)."
                      ),
                    ]),
                    _c("p", { staticClass: "text-muted small" }, [
                      _vm._v("Le lien est valide pendant 1 heure."),
                    ]),
                  ]),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "link" },
                      on: { click: _vm.resetForm },
                    },
                    [_vm._v(" Utiliser une autre adresse email ")]
                  ),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }